import * as React from 'react';
import { ArticleParagraph2 } from '@cian/ui-kit';
import * as styles from './EscrowBlock.css';
import { EscrowRoundIcon } from '../Escrow/EscrowIcons';
import { Link } from '../Link';

interface IReliableBlockProps {
  text: string;
  onClick(event: React.MouseEvent<HTMLElement>): void;
}

export function EscrowBlock({ text, onClick }: IReliableBlockProps) {
  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <EscrowRoundIcon />
      </div>
      <div>
        <ArticleParagraph2>{text}</ArticleParagraph2>
        <Link url={'#escrow'} onClick={onClick}>
          Узнать больше
        </Link>
      </div>
    </div>
  );
}
